module.exports = __webpack_public_path__ + "static/media/Gelt-front.69038dbd.PNG";